<template>
  <a-modal
    title="待办事项"
    style="top: 20px"
    v-model="visible"
    :width="1300"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleClose"
    :maskClosable="false"
  >
    <a-row :gutter="24" style="margin: 10px 0">
      <a-col :span="4">
        <p>今日已处理:{{ queryParam.Processed }}</p>
      </a-col>
      <!--<a-col :span="4">-->
      <!--<p>-->
      <!--处理中:{{queryParam.Processing}}-->
      <!--</p>-->
      <!--</a-col>-->
      <a-col :span="4">
        <p>未处理:{{ queryParam.Unprocessed }}</p>
      </a-col>
      <a-col :span="4" v-if="this.userType != 22">
        <p style="color: red">我的超时订单:{{ queryParam.MyOvertimeOrder }}</p>
      </a-col>
      <a-col :span="4" v-if="this.userType != 22">
        <p style="color: red">协助的超时订单:{{ queryParam.assistance }}</p>
      </a-col>
    </a-row>
    <a-tabs type="card" @change="callback">
      <a-tab-pane key="1" tab="投诉" v-if="complaintNum != 0">
        <div class="table-page-search-wrapper">
          <a-form :form="form" layout="inline">
            <a-row :gutter="6">
              <a-col :span="6">
                <a-form-item label="订单号" style="margin-left: 13px">
                  <a-input v-decorator="['orderNo', { rules: [{ required: false, message: '请输入订单号' }] }]" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="投诉类型" style="margin-left: 27px">
                  <a-select v-decorator="['matterCode', { rules: [{ required: false, message: '选择' }] }]">
                    <a-select-option :title="type.name" v-for="type in resTypes" :key="type.code">{{
                      type.name
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="投诉人" style="margin-left: 40px">
                  <a-input
                    v-decorator="['complainantName', { rules: [{ required: false, message: '请输入订单号' }] }]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="投诉人联系方式">
                  <a-input
                    v-decorator="['complainantPhone', { rules: [{ required: false, message: '请输入订单号' }] }]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="6">
              <!--              <a-col :span="6">-->
              <!--                <a-form-item label="当前处理人" style="margin-left: 13px">-->
              <!--                  <a-input  v-decorator="['currentHandlerName', { rules: [{ required: false, message: '请输入订单号' }] }]"/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :span="6">-->
              <!--                <a-form-item label="处理情况">-->
              <!--                  <a-select v-decorator="['handlingStatus', { rules: [{ required: false, message: '选择' }] }]" >-->
              <!--                    <a-select-option title="未处理" value="0">-->
              <!--                      未处理-->
              <!--                    </a-select-option>-->
              <!--                    <a-select-option title="处理中" value="1">-->
              <!--                      处理中-->
              <!--                    </a-select-option>-->
              <!--                    <a-select-option title="已处理" value="2">-->
              <!--                      已处理-->
              <!--                    </a-select-option>-->
              <!--                  </a-select>-->
              <!--                 </a-form-item>-->
              <!--              </a-col>-->
              <a-col :span="6">
                <a-form-item label="投诉时间">
                  <a-range-picker
                    v-decorator="['datatime1']"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                    }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChange1"
                    @ok="onOk"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <!--<a-col :span="6">-->
              <!--<a-form-item label="开始处理时间" >-->
              <!--<a-range-picker-->
              <!--v-decorator="['datatime2']"-->
              <!--:showTime="{ format: 'HH:mm:ss' }"-->
              <!--format="YYYY-MM-DD HH:mm:ss"-->
              <!--:placeholder="['开始时间', '结束时间']"-->
              <!--@change="onChange2"-->
              <!--@ok="onOk"-->
              <!--style="width:100%"-->
              <!--/>-->
              <!--</a-form-item>-->
              <!--</a-col>-->

              <!--<a-col :span="6">-->
              <!--<a-form-item label="处理完成时间" >-->
              <!--<a-range-picker-->
              <!--v-decorator="['datatime3']"-->
              <!--:showTime="{ format: 'HH:mm:ss' }"-->
              <!--format="YYYY-MM-DD HH:mm:ss"-->
              <!--:placeholder="['开始时间', '结束时间']"-->
              <!--@change="onChange3"-->
              <!--@ok="onOk"-->
              <!--style="width:100%"-->
              <!--/>-->
              <!--</a-form-item>-->
              <!--</a-col>-->

              <a-col :span="6">
                <a-form-item label="投诉内容" style="margin-left: 26px">
                  <a-input
                    v-decorator="['complaintContents', { rules: [{ required: false, message: '请输入投诉内容' }] }]"
                  />
                </a-form-item>
              </a-col>

              <!--              <a-col :span="6">-->
              <!--                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理时长">-->
              <!--                      <a-row>-->
              <!--                        <a-col :span="6">-->
              <!--                          <a-input v-model="querytime.textTime1"  @keyup.native="number1"/>-->
              <!--                        </a-col>-->
              <!--                        <a-col :span="2">-->
              <!--                          <span>至</span>-->
              <!--                        </a-col>-->

              <!--                        <a-col :span="6">-->
              <!--                          <a-input v-model="querytime.textTime2" @keyup.native="number2"/>-->
              <!--                        </a-col>-->
              <!--                        <a-col :span="10">-->
              <!--                          <a-select v-model="querytime.selectTime1"   @change="timeChange1">-->
              <!--                            <a-select-option value=""> 选择 </a-select-option>-->
              <!--                            <a-select-option title="天" value="d"> 天 </a-select-option>-->
              <!--                            <a-select-option title="小时" value="h"> 小时 </a-select-option>-->
              <!--                          </a-select>-->
              <!--                        </a-col>-->
              <!--                      </a-row>-->
              <!--                    </a-form-item>-->
              <!--              </a-col>-->

              <a-col :span="6">
                <a-form-item label="投诉对象" style="margin-left: 26px">
                  <a-input
                    v-decorator="['complaintObject', { rules: [{ required: false, message: '请输入投诉对象' }] }]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <!--            <a-row :gutter="6">-->
            <!--              <a-col :span="6">-->
            <!--                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总处理时长" style="margin-left: 13px;">-->
            <!--                  <a-row>-->
            <!--                    <a-col :span="6">-->
            <!--                      <a-input v-model="querytime.textTime3"  @keyup.native="number3"/>-->
            <!--                    </a-col>-->
            <!--                    <a-col :span="2">-->
            <!--                      <span>至</span>-->
            <!--                    </a-col>-->

            <!--                    <a-col :span="6">-->
            <!--                      <a-input v-model="querytime.textTime4" @keyup.native="number4"/>-->
            <!--                    </a-col>-->
            <!--                    <a-col :span="10">-->
            <!--                      <a-select v-model="querytime.selectTime2"   @change="timeChange2">-->
            <!--                        <a-select-option value=""> 选择 </a-select-option>-->
            <!--                        <a-select-option value="d"> 天 </a-select-option>-->
            <!--                        <a-select-option value="h"> 小时 </a-select-option>-->
            <!--                      </a-select>-->
            <!--                    </a-col>-->
            <!--                  </a-row>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--            </a-row>-->
            <a-row :gutter="6">
              <a-col :span="6"> </a-col>
            </a-row>
            <a-row :gutter="6" style="margin: 20px 0 50px 0">
              <a-col :span="16">
                <!--                <a-radio-group name="radioGroup" v-model="isMyCreate" @change="handleSelect">-->
                <!--                  <a-radio :value="'0'">-->
                <!--                    我的待办-->
                <!--                  </a-radio>-->
                <!--                  <a-radio :value="'1'">-->
                <!--                    我的发起-->
                <!--                  </a-radio>-->
                <!--                </a-radio-group>-->
              </a-col>
              <a-col :span="4" :offset="3">
                <span style="display: flex; justify-content: center">
                  <a-button
                    class="twobtn"
                    type="primary"
                    style="margin-left: 20px"
                    v-if="exportEnable"
                    @click="exporto()"
                  >导出</a-button
                  >
                  <!--<a-button class="twobtn" style="margin-left: 35px" type="primary" @click="exports()">导出订单</a-button>-->
                  <a-button
                    class="twobtn"
                    style="margin-left: 35px"
                    htmlType="submit"
                    type="primary"
                    @click="query()"
                  >查询</a-button
                  >
                  <a-button class="twobtn" style="margin-left: 35px" @click="restdata()">清空</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-table
            size="default"
            ref="table"
            rowKey="modelId"
            :pagination="pagination"
            :loading="loading"
            :columns="columns"
            :data-source="complaintData"
            :scroll="{ x: 200 }"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a-popover title="订单子状态">
                <template slot="content">
                  <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
                    <p v-for="item in record.orderSubStatusList">{{ item }}</p>
                  </div>
                </template>
                <a type="primary">
                  {{ text }}
                </a>
              </a-popover>
            </span>
            <span slot="action" slot-scope="text, record">
              <a v-if="record.statusCode < 3" @click="handles(record)">处理<a-divider type="vertical" /></a>

              <a
                v-if="record.statusCode < 2 && dispatchEnable"
                @click="Transfer(record)"
              >转派<a-divider
                type="vertical"
              /></a>

              <a-popover trigger="click" title="履历">
                <template slot="content">
                  <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
                    <div v-for="item in dataResume">
                      <p>履历内容:{{ item.content }}</p>
                      <p>操作人姓名:{{ item.createName }}</p>
                      <p>操作时间:{{ item.createTime }}</p>
                      <a-divider type="vertical" />
                    </div>
                  </div>
                </template>
                <a @click="Resume(record)" v-if="recodeEnable"> 履历 </a>
              </a-popover>
              <a
                v-if="record.handleStartTimeStart == ''"
                @click="withdraw(record)"
              ><a-divider type="vertical" />撤回</a
              >
            </span>
          </a-table>
          <!--分页-->
          <a-pagination
            show-size-changer
            show-quick-jumper
            :total="total"
            v-model="current"
            :pageSizeOptions="pageSizeOptions"
            :pageSize.sync="pageSize"
            @change="onChangePage"
            @showSizeChange="onShowSizeChange"
            :showTotal="(total) => `总共 ${total} 条`"
            style="float: right; margin: 30px 10px 10px 0"
          />
          <!--转派弹框-->
          <a-modal
            title="转派"
            :width="800"
            v-model="visible2"
            :confirmLoading="confirmLoading2"
            @ok="handleSubmit2"
            :closable="false"
            :maskClosable="false"
          >
            <a-form :form="form2" layout="inline">
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="转派角色">
                    <a-select
                      v-decorator="['roleCode', { rules: [{ required: false, message: '选择' }] }]"
                      style="width: 300px"
                    >
                      <a-select-option v-for="type in Roledata" :key="type.code">{{ type.name }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-modal>
          <edit-order-model v-if="$store.state.user_type == 1" ref="editorder" @Ok="query()"></edit-order-model>
          <edit-order-model1 v-else ref="editorder" @Ok="query()"></edit-order-model1>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" tab="问题反馈" v-if="feedbackNum != 0">
        <problem ref="model2" @Ok="handleSubmit()"></problem>
      </a-tab-pane>

      <a-tab-pane key="3" tab="审核" v-if="auditNum != 0">
        <toexamine ref="model3" @Ok="handleSubmit()"></toexamine>
      </a-tab-pane>

      <a-tab-pane key="4" tab="配件" v-if="fittingNum != 0">
        <parts ref="model4" @Ok="handleSubmit()"></parts>
      </a-tab-pane>

      <a-tab-pane key="5" tab="财务" v-if="financialAffairsNum != 0">
        <finance ref="model5" @Ok="handleSubmit()"></finance>
      </a-tab-pane>

      <a-tab-pane key="6" tab="预警" v-if="warningNum != 0">
        <earlywarning ref="model6" @ok="handleSubmit(arguments)"></earlywarning>
      </a-tab-pane>

      <a-tab-pane key="7" tab="超时" v-if="timeoutNum != 0">
        <overtime ref="model7" @Ok="handleSubmit()"></overtime>
      </a-tab-pane>

      <!--<a-tab-pane key="8" tab="已处理">-->
      <!--<processed ref="model8"></processed>-->
      <!--</a-tab-pane>-->
    </a-tabs>
  </a-modal>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Problem from './Problem.vue'
import Processed from './Processed.vue'
import Toexamine from './Toexamine.vue'
import Overtime from './Overtime.vue'
import Earlywarning from './Earlywarning.vue'
import Finance from './Finance.vue'
import Backlog from './Backlog.vue'
import Parts from './Parts.vue'
import store from '@/store'
import moment from 'moment'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'Backlog',
  components: {
    Problem,
    Toexamine,
    Processed,
    Overtime,
    Earlywarning,
    Finance,
    Parts,
    Backlog,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1')
  },
  data () {
    return {
      store,
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      userType: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      batchEnable: checkPermission('toDo:batch'), // 批量处理
      exportEnable: checkPermission('toDo:export'), // 导出
      dispatchEnable: checkPermission('toDo:dispatch'), // 转派
      recodeEnable: checkPermission('toDo:recode'), // 履历
      Roledata: [], // 转派角色
      resTypes: [],
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      queryParam: {},
      visible: false,
      confirmLoading: false,
      visible2: false,
      confirmLoading2: false,
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'no',
          width: '70px',
          align: 'center'
        },
        {
          title: '操作',
          width: '80px',
          dataIndex: 'statusArea',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '处理情况',
          dataIndex: 'handlingStatus',
          align: 'center'
        },
        {
          title: '投诉类型',
          dataIndex: 'matterName',
          align: 'center'
        },
        {
          title: '投诉内容',
          dataIndex: 'contents',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipalName',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusName',
          align: 'center'
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatusName',
          align: 'center',
          scopedSlots: { customRender: 'action2' }
        },
        {
          title: '投诉人',
          dataIndex: 'complainantName',
          align: 'center'
        },
        {
          title: '投诉人联系方式',
          dataIndex: 'complaintPhone',
          align: 'center'
        },

        {
          title: '投诉对象',
          dataIndex: 'complaintObjectName',
          align: 'center'
        },
        {
          title: '被投诉人',
          dataIndex: 'respondentName',
          align: 'center'
        },
        {
          title: '投诉时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installTypeName',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center'
        },
        {
          title: '客户电话',
          dataIndex: 'clientPhone',
          align: 'center'
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipalName',
          align: 'center'
        }
        // {
        //   title: '当前协助人',
        //   dataIndex: 'helperName',
        //   align:'center'
        // },
        // {
        //   title: '师傅姓名',
        //   dataIndex: 'workName',
        //   align:'center'
        // },
        // {
        //   title: '师傅联系方式',
        //   dataIndex: 'workPhone',
        //   align:'center'
        // },
        // {
        //   title: '师傅负责人姓名',
        //   dataIndex: 'masterLeadingName',
        //   align:'center'
        // },
        // {
        //   title: '当前处理人姓名',
        //   dataIndex: 'currentHandlerName',
        //   align:'center'
        // },
        // {
        //   title: '处理时长',
        //   dataIndex: 'processingTimeInfo',
        //   align:'center'
        // },
        // {
        //   title: '开始处理时间',
        //   dataIndex: 'handleStartTime',
        //   align:'center'
        // },
        // {
        //   title: '总处理时长',
        //   dataIndex: 'totalProcessingTimeInfo',
        //   align:'center'
        // }
      ],
      pagination: false,
      loading: true,
      complaintData: [],
      querytime: {},
      isMyOrder: false,
      isMyCreate: '0',
      complaintsHeaderId: '',
      total: 0,
      // current:1,
      pageSize: 10,
      pageNum: 1,
      dataResume: [],
      auditNum: '',
      complaintNum: '',
      feedbackNum: '',
      financialAffairsNum: '',
      fittingNum: '',
      timeoutNum: '',
      warningNum: '',
      firstIndex: '',
      val: ''
    }
  },
  methods: {
    moment,
    handleCount () {
      // 获取头部处理订单
      this.$axios({
        method: 'get',
        url: '/api/backlog/union/count',
        params: {},
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        this.$store.state.backNum = res.data.data.total
        this.$store.commit('changeBackNum', res.data.data.unProcessIdNum)
        this.queryParam.Processed = res.data.data.endNom
        // this.queryParam.Processing=res.data.data.inProcessIdNum
        this.queryParam.Unprocessed = res.data.data.unProcessIdNum
        this.queryParam.MyOvertimeOrder = res.data.data.myOutTimeOrderNum
        this.queryParam.assistance = res.data.data.myHelpOutTimeOrderNum
      })
    },
    // 履历
    Resume (values) {
      this.$axios({
        method: 'get',
        url: '/api/backlog/pendingMatter/getPendingMattersResume',
        params: {
          pendingMattersRecordId: values.complaintsHeaderId,
          matterCode: values.matterCode
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        console.log(res)
        this.dataResume = res.data.data
      })
      // /pendingMatter/getPendingMattersResume
    },

    // 分页
    onChangePage (page, pageNumber) {
      // this.current = page
      // console.log(page,pageNumber)
      this.pageNum = page
      this.query()
    },
    onShowSizeChange (current, pageSize) {
      // console.log(current, pageSize)
      this.pageSize = pageSize
      this.pageNum = current
      this.query()
    },
    // 撤回
    withdraw (value) {
      console.log(value)
      this.$axios({
        method: 'post',
        url: '/api/backlog/complaints/revoke',
        params: {
          complaintsHeaderId: value.complaintsHeaderId
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        console.log(res)
        if (res.data.code == 0) {
          this.$message.success('撤回成功')
          this.query()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 导出
    exporto () {
      this.form.validateFields((err, values) => {
        values.isMyCreate = this.isMyCreate
        values.pageSize = this.pageSize
        values.pageNum = this.pageNum
        values.complaintTimeStart = this.querytime.complaintTimeStart
        values.complaintTimeEnd = this.querytime.complaintTimeEnd
        values.handleStartTimeStart = this.querytime.handleStartTimeStart
        values.handleStartTimeEnd = this.querytime.handleStartTimeEnd
        values.handleEndTimeStart = this.querytime.handleEndTimeStart
        values.handleEndTimeEnd = this.querytime.handleEndTimeEnd
        values.processingTimeStart = this.querytime.textTime1
        values.processingTimeEnd = this.querytime.textTime2
        values.processingTimeType = this.querytime.selectTime1
        values.totalProcessingTimeStart = this.querytime.textTime3
        values.totalProcessingTimeEnd = this.querytime.textTime4
        values.totalProcessingTimeType = this.querytime.selectTime2
        delete values.datatime3
        delete values.datatime1
        delete values.datatime2

        var str = process.env.VUE_APP_API_BASE_URL + '/backlog/complaints/export?pageSize=10&pageNum=1'

        for (const i in values) {
          if (values[i] != undefined) {
            str = str + '&' + i + '=' + values[i]
          }
        }
        str = str + '&token=' + this.headers.token
        console.log(str, '导出出')
        window.open(str)

        // this.$axios({
        //   method: "get",
        //   url: "/api/backlog/audit/export",
        //   params:values,
        //   responseType: 'arraybuffer',
        //   headers: {
        //     token: Vue.ls.get(ACCESS_TOKEN),
        //     'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //   }
        // }).then((res) => {
        //     const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        //     const a = document.createElement('a')
        //     // 生成文件路径
        //     let href = window.URL.createObjectURL(blob)
        //     a.href = href
        //     let fileName = '投诉'
        //     // 文件名中有中文 则对文件名进行转码
        //     a.download = decodeURIComponent(fileName)
        //     // 利用a标签做下载
        //     document.body.appendChild(a)
        //     a.click()
        //     document.body.removeChild(a)
        //     window.URL.revokeObjectURL(href)
        // })
      })
    },
    // 时间区间
    timeChange1 (value) {
      console.log(value)
      this.querytime.selectTime1 = value
    },
    timeChange2 (value) {
      console.log(value)
      this.querytime.selectTime2 = value
    },
    handleSelect () {
      // this.pageNum = 1
      // this.current = 1
    },
    number1 () {
      this.regular(this.querytime.textTime1)
    },
    number2 () {
      this.regular(this.querytime.textTime2)
    },
    number3 () {
      this.regular(this.querytime.textTime3)
    },
    number4 () {
      this.regular(this.querytime.textTime4)
    },
    regular (value) {
      value = value.replace(/[^\.\d]/g, '')
      value = value.replace('.', '')
    },
    restdata () {
      this.isMyCreate = '0'
      this.form.resetFields()
      this.querytime = {}
      this.query()
    },
    // 处理
    handles (value) {
      if (value.jumpUrl === 'orderPriceInfo') {
        // 订单详情-金额信息
        // this.$router.push({path:'/order/orderList', query:{orderNo: value.orderNo}})
        //  this.visible=false
        const that = this
        this.$refs.editorder.showeditOrder(value.orderId, 2, 1, '', value.auditStatus, 0, 1)
        setTimeout(function () {
          that.$refs.editorder.examine()
        }, 1000)
      } else if (value.jumpUrl === 'orderInfo') {
        // 订单详情
        // this.$router.push({path:'/order/orderList', query:{orderNo: value.orderNo}})
        // this.visible=false
        this.$refs.editorder.showeditOrder(value.orderId, 1, 1, '', value.auditStatus, 0, 1)
      }
    },
    add (val) {
      console.log(val)
      this.visible = true
      this.isMyCreate = '0'
      this.val = val
      // 统计
      this.$axios({
        method: 'get',
        url: '/api/backlog/union/countMyPending',
        params: {},
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        // console.log(res)
        if (this.val == 'back') {
          this.firstIndex = 2
          this.auditNum = 0
          this.complaintNum = 0
          this.feedbackNum = 1
          this.financialAffairsNum = 0
          this.fittingNum = 0
          this.timeoutNum = 0
          this.warningNum = 0
        } else if (this.val == 'complaints') {
          this.firstIndex = 1
          this.auditNum = 0
          this.complaintNum = 1
          this.feedbackNum = 0
          this.financialAffairsNum = 0
          this.fittingNum = 0
          this.timeoutNum = 0
          this.warningNum = 0
        } else {
          this.firstIndex = res.data.data.firstIndex
          this.auditNum = res.data.data.auditNum
          this.complaintNum = res.data.data.complaintNum
          this.feedbackNum = res.data.data.feedbackNum
          this.financialAffairsNum = res.data.data.financialAffairsNum
          this.fittingNum = res.data.data.fittingNum
          this.timeoutNum = res.data.data.timeoutNum
          this.warningNum = res.data.data.warningNum
        }
        console.log(this.firstIndex)
        // 获取投诉列表数据
        if (this.firstIndex == 1) {
          this.query()
        } else {
          this.$nextTick(() => {
            this.callback(this.firstIndex)
          })
        }
        this.handleCount()
      })
    },
    // 投诉时间
    onChange1 (date, dateString) {
      console.log(dateString[0], dateString[1])
      this.querytime.complaintTimeStart = dateString[0]
      this.querytime.complaintTimeEnd = dateString[1]
    },
    // 开始处理时间
    onChange2 (date, dateString) {
      this.querytime.handleStartTimeStart = dateString[0]
      this.querytime.handleStartTimeEnd = dateString[1]
    },
    // 处理完成时间
    onChange3 (date, dateString) {
      this.querytime.handleEndTimeStart = dateString[0]
      this.querytime.handleEndTimeEnd = dateString[1]
    },
    // 数据表格刷新
    dataList (values) {
      this.$axios({
        method: 'get',
        url: '/api/backlog/complaints/getComplaintsList',
        params: values,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        this.loading = false
        this.complaintData = res.data.rows
        this.total = res.data.total
        this.handleCount()
      })
    },
    // 查询
    query () {
      this.form.validateFields((err, values) => {
        values.isMyCreate = this.isMyCreate
        if (values.isMyCreate == 1) {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'no',
              width: '70px',
              align: 'center'
            },
            {
              title: '处理情况',
              dataIndex: 'handlingStatus',
              align: 'center'
            },
            {
              title: '投诉类型',
              dataIndex: 'matterName',
              align: 'center'
            },
            {
              title: '投诉内容',
              dataIndex: 'contents',
              align: 'center'
            },
            {
              title: '订单号',
              dataIndex: 'orderNo',
              align: 'center'
            },
            {
              title: '企业名称',
              dataIndex: 'enterpriseName',
              align: 'center'
            },
            {
              title: '市场负责人',
              dataIndex: 'marketPrincipalName',
              align: 'center'
            },
            {
              title: '订单状态',
              dataIndex: 'orderStatusName',
              align: 'center'
            },
            {
              title: '订单子状态',
              dataIndex: 'orderSubStatusName',
              align: 'center',
              scopedSlots: { customRender: 'action2' }
            },
            {
              title: '投诉人',
              dataIndex: 'complainantName',
              align: 'center'
            },
            {
              title: '投诉人联系方式',
              dataIndex: 'complaintPhone',
              align: 'center'
            },

            {
              title: '投诉对象',
              dataIndex: 'complaintObjectName',
              align: 'center'
            },
            {
              title: '被投诉人',
              dataIndex: 'respondentName',
              align: 'center'
            },
            {
              title: '投诉时间',
              dataIndex: 'createTime',
              align: 'center'
            },
            {
              title: '安装类别',
              dataIndex: 'installTypeName',
              align: 'center'
            },
            {
              title: '订单类型',
              dataIndex: 'orderTypeName',
              align: 'center'
            },
            {
              title: '客户姓名',
              dataIndex: 'clientName',
              align: 'center'
            },
            {
              title: '客户电话',
              dataIndex: 'clientPhone',
              align: 'center'
            },
            {
              title: '订单负责人',
              dataIndex: 'orderPrincipalName',
              align: 'center'
            }
            // {
            //   title: '当前协助人',
            //   dataIndex: 'helperName',
            //   align:'center'
            // },
            // {
            //   title: '师傅姓名',
            //   dataIndex: 'workName',
            //   align:'center'
            // },
            // {
            //   title: '师傅联系方式',
            //   dataIndex: 'workPhone',
            //   align:'center'
            // },
            // {
            //   title: '师傅负责人姓名',
            //   dataIndex: 'masterLeadingName',
            //   align:'center'
            // },
            // {
            //   title: '当前处理人姓名',
            //   dataIndex: 'currentHandlerName',
            //   align:'center'
            // },
            // {
            //   title: '处理时长',
            //   dataIndex: 'processingTimeInfo',
            //   align:'center'
            // },
            // {
            //   title: '开始处理时间',
            //   dataIndex: 'handleStartTime',
            //   align:'center'
            // },
            // {
            //   title: '总处理时长',
            //   dataIndex: 'totalProcessingTimeInfo',
            //   align:'center'
            // }
          ]
        } else {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'no',
              width: '70px',
              align: 'center'
            },
            {
              title: '操作',
              width: '80px',
              dataIndex: 'statusArea',
              scopedSlots: { customRender: 'action' }
            },
            {
              title: '处理情况',
              dataIndex: 'handlingStatus',
              align: 'center'
            },
            {
              title: '投诉类型',
              dataIndex: 'matterName',
              align: 'center'
            },
            {
              title: '投诉内容',
              dataIndex: 'contents',
              align: 'center'
            },
            {
              title: '订单号',
              dataIndex: 'orderNo',
              align: 'center'
            },
            {
              title: '企业名称',
              dataIndex: 'enterpriseName',
              align: 'center'
            },
            {
              title: '市场负责人',
              dataIndex: 'marketPrincipalName',
              align: 'center'
            },
            {
              title: '订单状态',
              dataIndex: 'orderStatusName',
              align: 'center'
            },
            {
              title: '订单子状态',
              dataIndex: 'orderSubStatusName',
              align: 'center',
              scopedSlots: { customRender: 'action2' }
            },
            {
              title: '投诉人',
              dataIndex: 'complainantName',
              align: 'center'
            },
            {
              title: '投诉人联系方式',
              dataIndex: 'complaintPhone',
              align: 'center'
            },

            {
              title: '投诉对象',
              dataIndex: 'complaintObjectName',
              align: 'center'
            },
            {
              title: '被投诉人',
              dataIndex: 'respondentName',
              align: 'center'
            },
            {
              title: '投诉时间',
              dataIndex: 'createTime',
              align: 'center'
            },
            {
              title: '安装类别',
              dataIndex: 'installTypeName',
              align: 'center'
            },
            {
              title: '订单类型',
              dataIndex: 'orderTypeName',
              align: 'center'
            },
            {
              title: '客户姓名',
              dataIndex: 'clientName',
              align: 'center'
            },
            {
              title: '客户电话',
              dataIndex: 'clientPhone',
              align: 'center'
            },
            {
              title: '订单负责人',
              dataIndex: 'orderPrincipalName',
              align: 'center'
            }
            // {
            //   title: '当前协助人',
            //   dataIndex: 'helperName',
            //   align:'center'
            // },
            // {
            //   title: '师傅姓名',
            //   dataIndex: 'workName',
            //   align:'center'
            // },
            // {
            //   title: '师傅联系方式',
            //   dataIndex: 'workPhone',
            //   align:'center'
            // },
            // {
            //   title: '师傅负责人姓名',
            //   dataIndex: 'masterLeadingName',
            //   align:'center'
            // },
            // {
            //   title: '当前处理人姓名',
            //   dataIndex: 'currentHandlerName',
            //   align:'center'
            // },
            // {
            //   title: '处理时长',
            //   dataIndex: 'processingTimeInfo',
            //   align:'center'
            // },
            // {
            //   title: '开始处理时间',
            //   dataIndex: 'handleStartTime',
            //   align:'center'
            // },
            // {
            //   title: '总处理时长',
            //   dataIndex: 'totalProcessingTimeInfo',
            //   align:'center'
            // }
          ]
        }
        values.pageSize = this.pageSize
        values.pageNum = this.pageNum
        values.complaintTimeStart = this.querytime.complaintTimeStart
        values.complaintTimeEnd = this.querytime.complaintTimeEnd
        values.handleStartTimeStart = this.querytime.handleStartTimeStart
        values.handleStartTimeEnd = this.querytime.handleStartTimeEnd
        values.handleEndTimeStart = this.querytime.handleEndTimeStart
        values.handleEndTimeEnd = this.querytime.handleEndTimeEnd
        values.processingTimeStart = this.querytime.textTime1
        values.processingTimeEnd = this.querytime.textTime2
        values.processingTimeType = this.querytime.selectTime1
        values.totalProcessingTimeStart = this.querytime.textTime3
        values.totalProcessingTimeEnd = this.querytime.textTime4
        values.totalProcessingTimeType = this.querytime.selectTime2
        delete values.datatime3
        delete values.datatime1
        delete values.datatime2
        this.dataList(values)
      })
    },
    // tab切换
    callback (key) {
      console.log(key)
      if (key == 2) {
        this.$nextTick(() => {
          this.$refs.model2.query()
        })
      } else if (key == 3) {
        this.$nextTick(() => {
          this.$refs.model3.query()
        })
      } else if (key == 4) {
        this.$nextTick(() => {
          this.$refs.model4.query()
        })
      } else if (key == 5) {
        this.$nextTick(() => {
          this.$refs.model5.query()
        })
      } else if (key == 6) {
        this.$nextTick(() => {
          this.$refs.model6.query()
        })
      } else if (key == 7) {
        this.$nextTick(() => {
          this.$refs.model7.query()
        })
      } else if (key == 1) {
        this.$nextTick(() => {
          this.query()
        })
      }
      // else if(key==8){
      //   this.$refs.model8
      // }
    },
    // 转派提交
    handleSubmit2 () {
      console.log('转派')
      this.form2.validateFields((err, values) => {
        this.$axios({
          method: 'post',
          url: '/api/backlog/complaints/transfer',
          params: {
            complaintsHeaderId: this.complaintsHeaderId,
            roleCode: values.roleCode
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          console.log(res)
          if (res.data.code == 0) {
            this.$message.success('转派成功')
            this.visible2 = false
          } else {
            this.$message.success(res.data.msg)
          }
        })
      })
    },
    handleSubmit (userDefined) {
      if (userDefined != undefined && userDefined.length != 0) {
        this.visible = false
      } else {
        this.handleCount()
      }
    },
    // 转派
    Transfer (value) {
      this.visible2 = true
      this.complaintsHeaderId = value.complaintsHeaderId
      console.log(value)
      // 获取转派角色列表
      this.$axios({
        method: 'get',
        url: '/api/backlog/pendingMatter/getPendingMattersRoleList',
        params: {
          type: ''
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        this.Roledata = res.data.data
      })
    },
    handleClose () {
      this.visible = false
    }
  },
  created () {
    this.userType = this.store.getters.userType
    // console.log(this.manageTime)
    this.handleCount()
    // 获取投诉类型下拉框
    this.$axios({
      method: 'get',
      url: '/api/backlog/pendingMatter/getPendingMatterMenu',
      params: {
        matterTypeCode: 'complaints'
      },
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then((res) => {
      this.resTypes = res.data.data
      // console.log(res.data.data,'获取投诉类型下拉框')
    })
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>
